import React from 'react';

//Components
import UserAvatar from '../../common/UserAvatar/UserAvatar';

//Utils
import {detailsNavigationIds} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';
import {isValidArray} from '@stencil/hotels-utils/src/common-utils';

//Analytics
import useOmnitureLoaded from '@stencil/omniture-analytics/src/hooks/useOmnitureLoaded';
import {detailsClick} from '@stencil/omniture-analytics/src/constants/details';

//Styles
import * as S from './HostInfoUI.styles';

//Types
import {HostInfoShape} from '@stencil/hotels-cg-reducer/src/details/types';

interface HostInfoUIProps {
  hostInfo?: HostInfoShape;
  renderHostListInfo: () => void;
  onHostImageClick: () => void;
  onReadMoreClick: () => void;
}

const HostInfoUI: React.FC<HostInfoUIProps> = ({
  hostInfo,
  renderHostListInfo,
  onHostImageClick,
  onReadMoreClick,
}) => {
  useOmnitureLoaded(detailsClick.hostInfo.hostCardLoaded);

  const hostAbout = hostInfo?.about;
  return (
    <S.HostSection id={detailsNavigationIds.hostedBy}>
      <S.Container>
        {!!hostInfo?.name && <S.Title>Hosted by {hostInfo?.name}</S.Title>}
        <S.Content>
          <S.ContentLeft>
            <S.HostList>{renderHostListInfo()}</S.HostList>
            {hostAbout && (
              <S.HostBioWrapper>
                <S.HostBio>{hostAbout}</S.HostBio>
                <a onClick={onReadMoreClick}>Read More</a>
              </S.HostBioWrapper>
            )}
            {!!hostInfo?.caretakerAvailability && (
              <S.Responsibilities>
                <div dangerouslySetInnerHTML={{__html: hostInfo?.caretakerAvailability}} />
              </S.Responsibilities>
            )}
            {isValidArray(hostInfo?.caretakerResponsibilities) && (
              <S.Responsibilities>
                <span className="latoBold">Caretaker Responsibilities:</span>{' '}
                {hostInfo?.caretakerResponsibilities?.join(', ')}
              </S.Responsibilities>
            )}
          </S.ContentLeft>
          <S.HostImg onClick={hostInfo?.hostImage && onHostImageClick}>
            <UserAvatar userImg={hostInfo?.hostImage} firstName={hostInfo?.name} size={'15.4rem'} />
          </S.HostImg>
        </S.Content>
      </S.Container>
    </S.HostSection>
  );
};

export default HostInfoUI;
